export default function Footer() {
  return (
    <footer className="footer">
      <small>
        Coded with ❤️ by{" "}
        <a
          className="footer--link"
          href="https://emanueledelmonte.it"
          target="_blank"
          rel="noreferrer"
        >
          Emanuele Del Monte
        </a>
        .
      </small>
    </footer>
  );
}
